import { Controller } from "@hotwired/stimulus"

// Small-screen menu sheet for the marketing nav pill. The sheet only exists
// below `md`; above that the pill shows every link inline and the toggle is
// hidden, so a stray open state has to be cleaned up on resize.
export default class extends Controller {
  static targets = ["sheet", "toggle", "icon"]

  connect() {
    this.onKeydown = (event) => {
      if (event.key === "Escape") this.close()
    }
    this.onOutsideClick = (event) => {
      if (!this.isOpen) return
      if (this.element.contains(event.target)) return
      this.close()
    }
    this.onResize = () => {
      // 768px === Tailwind's `md`, where the inline links take over.
      if (window.innerWidth >= 768) this.close()
    }

    document.addEventListener("keydown", this.onKeydown)
    document.addEventListener("click", this.onOutsideClick)
    window.addEventListener("resize", this.onResize)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
    document.removeEventListener("click", this.onOutsideClick)
    window.removeEventListener("resize", this.onResize)
  }

  get isOpen() {
    return !this.sheetTarget.hidden
  }

  toggle() {
    this.isOpen ? this.close() : this.open()
  }

  open() {
    this.sheetTarget.hidden = false
    this.toggleTarget.setAttribute("aria-expanded", "true")
    this.toggleTarget.setAttribute("aria-label", "Close menu")
    this.iconTarget.classList.replace("ti-menu-2", "ti-x")
  }

  close() {
    if (!this.isOpen) return
    this.sheetTarget.hidden = true
    this.toggleTarget.setAttribute("aria-expanded", "false")
    this.toggleTarget.setAttribute("aria-label", "Open menu")
    this.iconTarget.classList.replace("ti-x", "ti-menu-2")
  }
}
